import { get } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { and, not, or } from 'ember-truth-helpers';

import { getRecordType } from 'umg-ember-backend/utils/get-record-type';
import { labelValueOptions } from 'umg-ember-backend/utils/intl';

export default class PageBuilderOptionsDisplayOptions extends Component {
  // Services
  @service intl;
  @service pageBuilderFrontendApi;

  // Defaults
  styles = ['DEFAULT', 'CUSTOM'];

  // Getter and setter
  get displayVariantOptions() {
    const { form, elementConfig } = this.args;
    const { type, collectionType } = form.model;
    const displayVariants = elementConfig?.options?.displayVariants;

    if (type === 'collection') {
      return displayVariants?.[collectionType];
    } else {
      return displayVariants;
    }
  }

  get hasDisplayVarianst() {
    return this.displayVariantOptions?.length > 0;
  }

  get isContentItemOption() {
    return getRecordType(this.args.form.model) === 'content-item';
  }

  get isContentItemProduct() {
    return this.args.form.model.type === 'product';
  }

  get styleOptions() {
    return labelValueOptions.call(this, this.styles, [
      'forms.content-item.options.style',
    ]);
  }

  // Template
  <template>
    <@form.fieldset
      @titleKey='displayOptions'
      @showSelectedAttributesIndicator={{true}}
      as |fieldset|
    >
      {{#if this.isContentItemOption}}
        {{#if this.hasDisplayVarianst}}
          <fieldset.field
            @property='options.displayVariant'
            @type='select-value'
            @options={{this.displayVariantOptions}}
          />
        {{/if}}

        {{#if this.isProductCollection}}
          <fieldset.field
            @property='options.buttonColor'
            @type='color'
            @colorFormat='rgba'
          />
        {{/if}}

        {{#if (and this.isContentItemProduct (not @mlp.isV2))}}
          <fieldset.field
            @property='options.style'
            @type='select-value'
            @options={{this.styleOptions}}
            @selected={{or @form.model.options.style (get this.styleOptions 0)}}
          />
        {{/if}}
      {{/if}}
    </@form.fieldset>
  </template>
}
